import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCanceledReportSlice = (set, get) => ({
    canceled: {
        loading: false,
        data: [],
        filtered: []
    },
    getCanceledInfo: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ canceled: { ...state.canceled, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: "/v1/business/business-Canceled-report",
                headers: { token },
            });
            set(state => ({ canceled: { loading: false, data: resp.data, filtered: resp.data } }));
        } catch (error) {
            set(state => ({ canceled: { ...state.canceled, loading: false } }));
        }
    }
});
